import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { PartnerEmailPreviewComponent } from './partner-email-preview/partner-email-preview.component';
import { SmbEmailPreviewDialogComponent } from './smb-email-preview/smb-email-preview.component';
import { EmailsComponent } from './emails.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { FilesizePipe } from '../../shared/pipes/filesize.pipe';
import { VaFilterModule, VaSearchBoxModule } from '@vendasta/uikit';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule, Routes } from '@angular/router';
import { FilterModule } from '@vendasta/va-filter2';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { EmailEventService, EmailService } from '@vendasta/email';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

const routes: Routes = [
  {
    path: '',
    component: EmailsComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    MatTabsModule,
    MatIconModule,
    FilesizePipe,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    VaFilterModule,
    VaSearchBoxModule,
    FilterModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,

    MatProgressSpinnerModule,
    GalaxyPageModule,
    ProductAnalyticsModule,
    GalaxyPipesModule,
  ],
  declarations: [PartnerEmailPreviewComponent, SmbEmailPreviewDialogComponent, EmailsComponent],
  exports: [RouterModule],
  providers: [EmailEventService, EmailService],
})
export class EmailsModule {}
